export const LOAD_RAWMAT_REVIEW_DATA = 'rawMatDataReviewWizard/LOAD_RAWMAT_REVIEW_DATA';
export const UPDATE_RAWMAR_REVIEW_DATA = 'rawMatDataReviewWizard/UPDATE_RAWMAR_REVIEW_DATA';
export const RESET_COMMENT = 'rawMatDataReviewWizard/RESET_COMMENT';
